// extracted by mini-css-extract-plugin
export default {"productGrid":"X8-z","centerLink":"Y8-z","productSection":"Z8-z","item":"_8-z","ctaButton":"a9-z"};